<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button @click="dismiss">
            <ion-icon slot="icon-only" :icon="icons.close"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>
          {{ $t('modals.procedure') }}
        </ion-title>
      </ion-toolbar>
      <ion-progress-bar v-if="loading" type="indeterminate"></ion-progress-bar>
    </ion-header>

    <ion-content :fullscreen="true">
      <template v-if="procedure">
        <div class="odn-procedure-name">
          {{ procedure.name }}
        </div>

        <!-- Files -->
        <ion-list v-if="procedureFiles.length > 0" lines="none">
          <ion-list-header>
            <ion-label>{{ $t('buttons.files') }}</ion-label>
          </ion-list-header>
          <ion-item
            v-for="procedureFile in procedureFiles"
            :key="procedureFile.id"
            button
            @click="onFile(procedureFile)"
          >
            <ion-icon :icon="icons.documentOutline" slot="start"></ion-icon>
            <ion-label class="ion-text-wrap">
              {{ procedureFile.originalname }}
            </ion-label>
          </ion-item>
        </ion-list>

        <!-- Content -->
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="procedure.content" class="odn-procedure-content"></div>
      </template>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonList,
  IonListHeader,
  IonItem,
  IonLabel,
  IonProgressBar,
  modalController,
  toastController,
} from '@ionic/vue';
import { close, documentOutline } from 'ionicons/icons';

import APIService from '@s/api.service';
import { openFile } from '@s/file-viewer';

export default {
  name: 'ModalProcedure',
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonList,
    IonListHeader,
    IonItem,
    IonLabel,
    IonProgressBar,
  },
  props: {
    procedureId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      procedure: null,
      procedureFiles: [],
      loading: true,
      icons: {
        close,
        documentOutline,
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const [procedure, procedureFiles] = await Promise.all([
          APIService.get(`/procedures/${this.procedureId}`),
          APIService.get(`/procedures/${this.procedureId}/files`, {
            page: 1,
            limit: 100,
            sort: 'originalname',
            direction: 'asc',
          }),
        ]);
        this.procedure = procedure.data;
        this.procedureFiles = procedureFiles.data.items;
      } catch (err) {
        const toast = await toastController.create({
          message: this.$t('messages.procedure.get.error'),
          color: 'danger',
          duration: 2000,
        });
        return toast.present();
      } finally {
        this.loading = false;
      }
    },
    onFile(procedureFile) {
      return openFile(procedureFile);
    },
    dismiss() {
      modalController.dismiss();
    },
  },
};
</script>

<style lang="scss" scoped>
.odn-procedure {
  &-name {
    padding: 16px 16px 8px 16px;
    font-size: 20px;
  }
  &-content {
    padding: 0 16px;
  }
}
</style>
